export const summaryItemsMappingTable: {[key: string]: string} = {
  'New + Upgraded ARR': '/data-input/contract-management/contracts?status=New,Upsell',
  'Out of Term': '/data-input/contract-management/contracts?status=Out%20of%20Term',
};

export const ALLOWED_NUMBER_OF_CARDS = 18;
export const PeriodOptions = [3, 6, 9, 12, 24, 48];
